import './FooterCustomer.css';
import '../../Assets/Styles/Customer/font-size.css';
import * as Service from '../../Services/service'
export default function FooterCustomer() {
    return (
        <footer>
            <div className="footer-buttons">
                <button className='button-footer-cus td-policy-customer' onClick={() => Service.openInNewTab('https://www.phuhunglife.com')}><a>Trang chủ Phú Hưng Life</a></button>
                <button className='button-footer-cus td-policy-customer' onClick={() => Service.openInNewTab('https://www.phuhunglife.com/vn/lien-he')}><a>Liên Hệ</a></button>
            </div>
            <div className="footer-description">
                <label>Bản quyền thuộc về Công ty Cổ phần Bảo hiểm Nhân thọ Phú Hưng. Tất cả các quyền được bảo hộ.</label>
            </div>
        </footer>
    )
};
